'use strict';
(function () {
    App.factory('lifeInsuranceSharedService', lifeInsuranceSharedServiceFactory);

    lifeInsuranceSharedServiceFactory.$inject = ['$rootScope'];

    function lifeInsuranceSharedServiceFactory($rootScope) {

        function LifeInsuranceSharedService() {
            console.log('[LifeInsuranceSharedService] service created');
            this.canAddPartnerOrSpouse = function (declarations, currentMode, currentPerson, availablePersons, currentPersonType, personsTypesList, isZoch) {

                console.log('[canAddPartnerOrSpouse] method called');

                var dataToApply = {};
                var cans = {canUserAddPartnerToSelf: false, canAddPartner: false, canAddSpouse: false};

                var declarationsOfUser = declarations.filter(function (declaration) {
                    let declarationType = declaration.revision.lifeInsurance.type;
                    return (declaration.declaration.type === 'USER') && (declarationType === 'FAMILY' || declarationType === 'PROTECTION');
                });

                var declarationsOfPartner = declarations.filter(function (declaration) {
                    return (declaration.declaration.type === 'PARTNER');
                });

                var declarationsOfPartnerOfUser = declarationsOfUser.filter(function (declaration) {
                    return declaration.revision.partner && declaration.revision.partner.id;
                });

                var declarationsOfUserWithPartnerInLastUserDeclaration = (declarationsOfUser.length ? [declarationsOfUser[0]] : []).filter(function (declaration) {
                    return declaration.revision.partner && declaration.revision.partner.id;
                });

                var declarationsOfSpouse = declarations.filter(function (declaration) {
                    return (declaration.declaration.type === 'SPOUSE');
                });

                if (!declarations.length) {
                    // Not partner or spouse is already added
                    cans.canUserAddPartnerToSelf = true;
                    cans.canAddPartner = false;
                    cans.canAddSpouse = false;
                } else {
                            // User has some declarations

                            // Partner is already added to user's declaration;
                            if (declarationsOfUser[0].revision.partner) {
                                cans.canUserAddPartnerToSelf = true;
                                cans.canAddPartner = true;
                                cans.canAddSpouse = false;
                                // Partner wasn't added to user's declaration
                            } else {
                                cans.canUserAddPartnerToSelf = true;
                                cans.canAddPartner = false;
                                cans.canAddSpouse = true;
                            }
                    }


                // if (!cans.canUserAddPartnerToSelf) {
                //     console.log('4', currentMode);
                //     if (currentMode !== 'NEW') {
                //         if (currentPersonType === 'USER' && currentPerson.partner && currentPerson.partner.id && (currentPerson.partner.type || '') !== 'SPOUSE') {
                //             cans.canUserAddPartnerToSelf = true;
                //         }
                //     }
                // }

                // Nowa declaracja, tylko dla zoch
                /*
                (A). Zmiana Małżonek na Partner

                1.	Nowa deklaracja dla pracownika ze wskazaniem Partnera życiowego
                2.	Nowa deklaracja dla Partnera życiowego – podstawiamy numer PESEL
                z deklaracji Pracownika z pozycji Partner Życiowy.
                3.	(API) Deklaracja dla Partnera życiowego może się stać zawarta/aktywna wyłącznie wtedy
                kiedy deklaracja dla Pracownika z wskazanym Partnerem życiowym
                jest w statusie Zawarta lub Aktywna.
                 */
                /*
                (B). Zmiana Partner na Małżonek

                1.	Nowa deklaracja dla pracownika bez wskazania
                2.	Nowa deklaracja dla Małżonka
                3.	(API) Deklaracja dla Małżonka może się stać zawarta/aktywna wyłącznie wtedy
                kiedy deklaracja dla Pracownika bez wskazania Partnera życiowego jest w
                statusie Zawarta lub Aktywna.
                 */
                if (currentMode === 'NEW' && isZoch) {
                    if (declarationsOfUserWithPartnerInLastUserDeclaration.length) {
                        cans.canAddSpouse = false;
                        if (declarationsOfSpouse.length) {
                            cans.canAddPartner = true; // a.d. A2

                            var partnerOfUserDeclaration = declarationsOfUserWithPartnerInLastUserDeclaration[0].revision.partner;
                            if (partnerOfUserDeclaration.identifierType === 'PESEL') {
                                dataToApply['PARTNER'] = {
                                    identifier: partnerOfUserDeclaration.identifier,
                                    identifierType: 'PESEL'
                                };
                            }
                        }
                    } else { // a.d. B1 (zawsze prawdziwe, user moze dodac deklaracje bez wskazania w kazdym przypadku)
                        cans.canAddSpouse = true; // a.d. B2
                        cans.canAddPartner = false;

                        // if (declarationsOfSpouse.length) { // a.d. A1
                        //
                        // cans.canUserAddPartnerToSelf = true;
                        //
                        // } else {
                        //
                        /*
                        -- Dodatkowo: https://trello.com/c/NbWuGTW9/709-zmiana-partnera-na-ma%C5%82%C5%BConka-i-zmiana-ma%C5%82%C5%BConka-na-partnera
                        -- W przypadku gdy pracownik posiada aktywną deklarację bez wskazania Partnera życiowego
                        -- nie ma możliwości dodania nowej deklaracji ze wskazaniem Partnera.
                        -- Musimy to jeszcze poprawić

                        -- declarationsOfUserWithPartnerInLastUserDeclaration.length = 0 i nie mam innych deklaracji
                        -- np. małżonka, to też powininenem móc wskazać partnera w deklaracji pracownika

                        -- Ostatecznie wychodzi masło maślane, bo tak czy siak canUserAddPartnerToSelf powinno być true
                         */
                        //
                        // cans.canUserAddPartnerToSelf = true;
                        //
                        // }

                        cans.canUserAddPartnerToSelf = true; // Ustawiamy na true poza zakomentowanym wyżej if-elsem
                    }
                }

                var selectToChange = personsTypesList.find(function (personType) {
                    return personType.type === 'PARTNER' || personType.type === 'SPOUSE';
                }) || {};

                var personToChange = {};
                if (currentMode === 'NEW') {
                    if (currentPerson.type === 'PARTNER' || currentPerson.type === 'SPOUSE') {
                        personToChange = currentPerson;
                    } else {
                        personToChange = availablePersons.find(function (personType) {
                            return personType.type === 'PARTNER' || personType.type === 'SPOUSE';
                        }) || {};
                    }
                }

                if (cans.canAddPartner && cans.canAddSpouse) {
                    selectToChange.name = 'Współmałżonek lub partner';
                    selectToChange.type = 'PARTNER';
                    personToChange.type = 'PARTNER';
                } else if (cans.canAddPartner) {
                    selectToChange.name = 'Partner';
                    selectToChange.type = 'PARTNER';
                    personToChange.type = 'PARTNER';
                } else if (cans.canAddSpouse) {
                    selectToChange.name = 'Współmałżonek';
                    selectToChange.type = 'SPOUSE';
                    personToChange.type = 'SPOUSE';
                }

                console.log('[canAddPartnerOrSpouse] assign cans', angular.copy(cans), angular.copy(personToChange), angular.copy(selectToChange));

                cans._dataToApply = dataToApply;

                return cans;
            };

            function oldCanAddPartnerOrSpouse(declarations, currentMode, currentPerson, availablePersons, currentPersonType, personsTypesList) {
                console.log('[canAddPartnerOrSpouse] method called');

                var cans = {canUserAddPartnerToSelf: false, canAddPartner: false, canAddSpouse: false};

                var declarationsOfUser = declarations.filter(function (declaration) {
                    return (declaration.declaration.type === 'USER');
                });

                var declarationsOfPartner = declarations.filter(function (declaration) {
                    return (declaration.declaration.type === 'PARTNER');
                });

                var declarationsOfSpouse = declarations.filter(function (declaration) {
                    return (declaration.declaration.type === 'SPOUSE');
                });

                if (!declarations.length) {
                    // Not partner or spouse is already added
                    cans.canUserAddPartnerToSelf = true;
                    cans.canAddPartner = true;
                    cans.canAddSpouse = true;
                } else {
                    if (declarationsOfPartner.length && declarationsOfSpouse.length) {
                        // Both partner and spouse was already added
                        cans.canUserAddPartnerToSelf = false;
                        cans.canAddPartner = false;
                        cans.canAddSpouse = false;
                    } else if (declarationsOfPartner.length) {
                        // Only partner is already added
                        cans.canUserAddPartnerToSelf = true;
                        cans.canAddPartner = true;
                        cans.canAddSpouse = false;
                    } else if (declarationsOfSpouse.length) {
                        // Only spouse is already added
                        cans.canUserAddPartnerToSelf = false;
                        cans.canAddSpouse = true;
                        cans.canAddPartner = false;
                    } else {
                        // Not partner or spouse is already added
                        if (declarationsOfUser.length) {
                            // User has some declarations

                            // Partner is already added to user's declaration;
                            if (declarationsOfUser[0].revision.partner) {
                                cans.canUserAddPartnerToSelf = true;
                                cans.canAddPartner = true;
                                cans.canAddSpouse = false;
                                // Partner wasn't added to user's declaration
                            } else {
                                cans.canUserAddPartnerToSelf = false;
                                cans.canAddPartner = false;
                                cans.canAddSpouse = true;
                            }
                        } else {
                            // User has not any declaration
                            cans.canUserAddPartnerToSelf = true;
                            cans.canAddPartner = true;
                            cans.canAddSpouse = true;
                        }
                    }
                }

                if (!cans.canUserAddPartnerToSelf) {
                    if (currentMode === 'CHANGE') {
                        if (currentPersonType === 'USER' && currentPerson.partner && currentPerson.partner.id && (currentPerson.partner.type || '') !== 'SPOUSE') {
                            cans.canUserAddPartnerToSelf = true;
                        }
                    }
                }

                var selectToChange = personsTypesList.find(function (personType) {
                    return personType.type === 'PARTNER' || personType.type === 'SPOUSE';
                }) || {};

                var personToChange = {};
                if (currentMode === 'NEW') {
                    if (currentPerson.type === 'PARTNER' || currentPerson.type === 'SPOUSE') {
                        personToChange = currentPerson;
                    } else {
                        personToChange = availablePersons.find(function (personType) {
                            return personType.type === 'PARTNER' || personType.type === 'SPOUSE';
                        }) || {};
                    }
                }

                if (cans.canAddPartner && cans.canAddSpouse) {
                    selectToChange.name = 'Współmałżonek lub partner';
                    selectToChange.type = 'PARTNER';
                    personToChange.type = 'PARTNER';
                } else if (cans.canAddPartner) {
                    selectToChange.name = 'Partner';
                    selectToChange.type = 'PARTNER';
                    personToChange.type = 'PARTNER';
                } else if (cans.canAddSpouse) {
                    selectToChange.name = 'Współmałżonek';
                    selectToChange.type = 'SPOUSE';
                    personToChange.type = 'SPOUSE';
                }

                console.log('[canAddPartnerOrSpouse] assign cans2 old', angular.copy(cans), angular.copy(personToChange), angular.copy(selectToChange));

                return cans;
            }
        }

        return new LifeInsuranceSharedService();
    }
})();
